/** The backend's range for `position` (UpdateScheduleMemberRequest). */
export const MIN_POSITION = 0;
export const MAX_POSITION = 1_000_000;

/** A typed position as the backend accepts it: a whole number clamped to 0–1,000,000, else null. */
export function parsePosition(value: string): number | null {
  const trimmed = value.trim();
  if (!/^-?\d+$/.test(trimmed)) return null;
  return Math.min(MAX_POSITION, Math.max(MIN_POSITION, Number(trimmed)));
}
